// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chilipiper-calendar {\n  width: 560px;\n  height: 861px;\n}\n", "",{"version":3,"sources":["webpack://./src/client/components/accounts-payable/chilipiper-calendar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":["#chilipiper-calendar {\n  width: 560px;\n  height: 861px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
